import React, { useState, useEffect, useRef } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";
import Loader from "../../../../Components/Loader/Loader";
import { editarTipoDispositivo, guardarTipoDispositivo } from "../../../../../API/IT/TipoDispositivos/TipoDispositivoRequest";

const TipoDispositivoCRUD = ({
  listTipoDispositivos,
  tipoDispositivoDialog,
  tipoDispositvo,
  setTipoDispositivoDialog,
  toastRef,
  getPos,
  modo,
}) => {
  const toastDialog = useRef(null);

  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdTipoDispositivo: -1,
    TipoDispositivo: "",
    CodigoInterno: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    setValues({
      ...tipoDispositvo,
      IdTipoDispositivo: tipoDispositvo?.IdTipoDispositivo,
      TipoDispositivo: tipoDispositvo?.TipoDispositivo,
      CodigoInterno: tipoDispositvo?.CodigoInterno,
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.TipoDispositivo) {
      error.TipoDispositivo = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const verificarDuplicado = () => {
    const duplicado = listTipoDispositivos.find(
      (r) =>
        r.IdTipoDispositivo !== values.IdTipoDispositivo &&
        r.IP === values.TipoDispositivo
    );

    if (duplicado) {
      let mensaje = "Ya existe una registro con el mismo valor de: ";
      if (duplicado.TipoDispositivo === values.TipoDispositivo)
        mensaje += `Tipo Dispositivo ${duplicado.TipoDispositivo} `;
      return mensaje;
    }

    return null;
  };

  const agregarTipoDispositivo = async () => {
    const e = verificarInfo();

    if (!e.error) {
      const duplicado = verificarDuplicado();

      if (duplicado) {
        toastShow(toastRef, "error", "Error", duplicado);
        return;
      }

      const a = {
        IdTipoDispositivo: values?.IdTipoDispositivo,
        TipoDispositivo: values.TipoDispositivo,
        CodigoInterno: values.CodigoInterno,
      };

      if (a.IdTipoDispositivo > 0) {
        setLoading(true);
        const resultado = await editarTipoDispositivo(a);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toastRef,
            "success",
            "Datos Editados",
            resultado[0]?.MENSAJE
          );
          getPos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastRef, "error", "Error", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarTipoDispositivo(a);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toastRef,
            "success",
            "Datos Agregados",
            resultado[0]?.MENSAJE
          );
          getPos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastRef, "error", "Error", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const onHide = () => {
    setTipoDispositivoDialog(false);
    resetForm();
    setShow(false);
  };

  useEffect(() => {
    if (tipoDispositivoDialog) {
      getValoresIniciales();
    }
  }, [tipoDispositivoDialog]);

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarTipoDispositivo();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  const dialogTitle = modo === "Crear" ? "Nuevo Tipo Dispositivo" : "Modificar Tipo Dispositivo";

  return (
    <div>
      <Toast ref={toastRef} />
      <ConfirmDialog />
      <Dialog
        visible={tipoDispositivoDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ margin: "auto" }}>
            {/* <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div> */}
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor gap-3">
              <div className="field col-6">
                <span className="p-float-label">
                  <InputText
                    name="TipoDispositivo"
                    value={values.TipoDispositivo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.TipoDispositivo ? "p-invalid" : ""}
                  />
                  <label htmlFor="TipoDispositivo">Tipo Dispositivo</label>
                </span>
              </div>
              <div className="field col-6">
                <span className="p-float-label">
                  <InputText
                    name="CodigoInterno"
                    value={values.CodigoInterno}
                    onInput={(e) => {
                      const valor = e.target.value;
                      if (valor.length > 5) {
                        e.target.value = valor.substring(0, 5);
                      }
                      handleInputChange(e);
                    }}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.CodigoInterno ? "p-invalid" : ""}
                  />
                  <label htmlFor="CodigoInterno">Código Interno</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default TipoDispositivoCRUD;
